import { datadogLogs } from '@datadog/browser-logs';
import {
    fetchPostUserConsent,
    PostUserConsentRequestBody
} from '@iwoca/lapi-client/edge';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export function useUserConsentMutation() {
    const stateKey = useStateKey();
    const queryClient = useQueryClient();

    const { mutateAsync, isLoading, isError } = useMutation({
        mutationFn: async ({
            body,
            provider
        }: {
            body: PostUserConsentRequestBody;
            provider: string;
        }) => {
            if (!import.meta.env.VITE_BUILD_HASH) {
                throw new Error('Missing build hash');
            }

            await fetchPostUserConsent({
                body,
                provider,
                stateKey
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['fetchGetUserConsent']
            });
        },
        onError: (error) => {
            datadogLogs.logger.error(
                'User consent failed to save',
                { VITE_BUILD_HASH: import.meta.env.VITE_BUILD_HASH },
                error as Error
            );
        }
    });

    return {
        postUserConsent: mutateAsync,
        isLoading,
        isError
    };
}
